/**
 * DimensionPills — the three verification dimensions (V1/V2/V3) as chips.
 *
 * Existence (V1) / Validity (V2) / Consistency (V3), each tinted by its own
 * tone. Labels and tones come from the shared maps (data-dictionary sourced).
 */
import * as React from 'react';
import type { Verdict } from '../../lib/veridoc-api';

import {
  CONSISTENCY_LABELS,
  DIMENSION_LABELS,
  EXISTENCE_LABELS,
  VALIDITY_LABELS,
} from './constants';
import {
  CONSISTENCY_TONE,
  EXISTENCE_TONE,
  TONE_CLASSES,
  VALIDITY_TONE,
  type Tone,
} from './verdictVisual';

function Pill({
  label,
  value,
  tone,
}: {
  label: string;
  value: string;
  tone: Tone;
}): React.JSX.Element {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-sm px-1.5 py-0.5 text-xs ${TONE_CLASSES[tone].pill}`}
    >
      <span className="opacity-70">{label}</span>
      <span className="font-medium">{value}</span>
    </span>
  );
}

export function DimensionPills({ verdict }: { verdict: Verdict }): React.JSX.Element {
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <Pill
        label={DIMENSION_LABELS.existence}
        value={EXISTENCE_LABELS[verdict.existence]}
        tone={EXISTENCE_TONE[verdict.existence]}
      />
      <Pill
        label={DIMENSION_LABELS.validity}
        value={VALIDITY_LABELS[verdict.validity]}
        tone={VALIDITY_TONE[verdict.validity]}
      />
      <Pill
        label={DIMENSION_LABELS.consistency}
        value={CONSISTENCY_LABELS[verdict.consistency]}
        tone={CONSISTENCY_TONE[verdict.consistency]}
      />
    </div>
  );
}

export default DimensionPills;
